<template>
  <div class="full-height">
    <div
    v-if="!reportForms"
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <crud-layout-search  ref="crudLayoutSearch" :name="name" :interface="nmInterface" :id="id" />
      </div>
    </div>
    <billing-order-exported-report v-else @on-close="onCloseReport" :format="reportFormat"  :forms="reportForms" />
    <q-dialog v-model="visible" persistent>
      <q-card>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">{{$gettext('REPORT_SELECTION')}}</span>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <q-radio v-model="reportFormat" val="pdf" label="PDF" />
          <q-radio v-model="reportFormat" val="xls" label="Excel" />
        </q-card-section>
      <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn :label="$gettext('CANCEL')" color="grey-7" v-close-popup class="q-px-lg" />
          <q-btn :label="$gettext('GENERATE')" color="info" v-close-popup @click="openDialogReport" class="q-px-lg" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import BillingOrderExportedReport from '../report/BillingOrderExportedReport.vue'

const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'BillingOrderBatchReportCrudLayout',
  components: { CrudLayoutSearch, BillingOrderExportedReport },
  props: {
    name: String,
    id: String
  }
})
class BillingOrderBatchReportCrudLayout extends Vue {
  nmInterface = 'batchReport.pesquisar';
  visible = false;
  reportFormat = 'pdf';
  reportParams = null;
  reportForms = null;

  onCloseReport () {
    this.reportForms = null
  }

  async openDialogReport (button, params) {
    const idParam = { ...this.reportParams, relFormatoRelatorio: this.relFormatoRelatorio }
    const repoForm = await repository.resolve('billingOrderExportedReport.billingOrderExportedReport', idParam)
    repoForm[0].dadosForm = { ...repoForm[0].dadosForm, ...idParam }
    this.reportForms = repoForm
  }

  actionButtonReport ({ params }) {
    this.visible = true
    this.reportParams = { exportBilling: params.exportBilling }
  }

  updated () {
    try {
      this.$refs.crudLayoutSearch.onButton('btGerar', this.actionButtonReport)
    } catch (error) {
    }
  }

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton('btGerar', this.actionButtonReport)
    } catch (error) {
      console.error(error)
    }
  }

  get relFormatoRelatorio () {
    return this.reportFormat === 'pdf' ? 1 : 3
  }
}
export default BillingOrderBatchReportCrudLayout
</script>
<style lang="stylus" scoped>

</style>
